import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNl = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 512,
	height: 512,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			stroke: "null",
			d: "m0,90l512,0l0,342l-512,0l0,-342z",
			fill: "#21468B"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "null",
			d: "m0,90l512,0l0,228l-512,0l0,-228z",
			fill: "#FFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "null",
			d: "m0,90l512,0l0,114l-512,0l0,-114z",
			fill: "#AE1C28"
		})
	]
});
export default SvgNl;
